import type { Skill } from "../skills";

export const skillsIniziali: Skill[] = [
  {
    id: "skill-riepiloghi",
    nome: "Riepiloghi chiari",
    descrizione: "Organizza le risposte in punti essenziali e facili da condividere.",
  },
  {
    id: "skill-scadenze",
    nome: "Controllo scadenze",
    descrizione: "Evidenzia le prossime attività e le date che richiedono attenzione.",
  },
];
